import { Component, Input, OnInit } from '@angular/core';
import { ModuleManager } from 'src/shared/models/module-manager';

@Component({
    selector: 'cv-contact-states-skill-settings',
    templateUrl: './contact-states-skill-settings.component.html',
    styleUrl: './contact-states-skill-settings.component.scss'
})
export class ContactStatesSkillSettingsComponent implements OnInit {
    @Input() moduleManager: ModuleManager;

    constructor() { }

    ngOnInit() {
        this.moduleManager.customSettingsAdded = true;
    }
}
